import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    myAccounts: gql`
        query MyAccounts {
            myAccounts {
                accounts {
                    username
                    phoneNumber
                    email
                    dateCreated
                    isInternalUser
                }
            }
        }
    `,
};
